import React, { forwardRef } from "react";
import Marquee from "react-fast-marquee";

const DropdownWrapper = forwardRef(
  (
    {
      isDisabled,
      popupClassName,
      heading,
      showPopup,
      isTextOverflowing,
      children,
    },
    ref,
  ) => {
    return (
      <>
        {isDisabled ? (
          <div
            className={`${
              popupClassName.dropDownContainerClass || ""
            } dropdown_btn is-disabled blueBorderColor`}
            role="button"
            aria-disabled="true"
            tabIndex={-1}
          >
            <p className="selected_text blueTextColor">
              {heading?.length > 19 && heading !== "No Sub Asset Classes"
                ? `${heading?.slice(0, 19)}...`
                : heading}
            </p>
          </div>
        ) : showPopup === false ? (
          <div
            className={`${popupClassName.dropDownContainerClass || ""} dropdown_btn`}
          >
            {isTextOverflowing ? (
              <Marquee speed={24} pauseOnHover gradient={false}>
                <p className="selected_text marquee-text">{heading}</p>
              </Marquee>
            ) : (
              <p
                className="selected_text"
                ref={ref}
                style={{ width: "calc(100% - 23px)", overflowX: "hidden" }}
              >
                {heading}
              </p>
            )}
          </div>
        ) : (
          <>{children}</>
        )}
      </>
    );
  },
);

export default DropdownWrapper;
